import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Ransack serializes dates as ISO (yyyy-mm-dd); reformat to dd/mm/yyyy
    const val = this.element.value;
    if (val && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
      const [y, m, d] = val.split('-');
      this.element.value = `${d}/${m}/${y}`;
    }

    new Datepicker(this.element, {
      format: 'dd/mm/yyyy'
    });
  }
}